<template>
  <transition name="fade">
    <div v-if="visible" class="modal-mask">
      <div class="modal-container">
        <div :class="isMobile ? 'h5-modal-close' : 'modal-close'" @click="handleClose">
          <img src="../../assets/svg/close.png" alt="close">
        </div>

        <div class="modal-content">
          <img :src="require(`../../assets/svg/${errorType}.png`)" class="error-icon" alt="icon"/>
          <span class="error-msg">{{ errorMsg }}</span>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "SysAlert",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: ""
    },
    errorType: {
      type: String,
      default: "failed"
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      this.$emit("close");
    }
  }
}
</script>

<style scoped lang="less">
.modal-mask {
  position: fixed;
  z-index: 9998; /* 确保在最顶层 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7); /* 背景变暗 */
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
}

.modal-container {
  position: relative;
  min-width: 178px;
  background-color: #fff;
  padding: 15px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
}

.modal-close {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.h5-modal-close {
  position: absolute;
  top: -0.55rem;
  right: -0.01rem;
  width: 0.3rem;
  height: 0.3rem;
  cursor: pointer;
}

.modal-content {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 13px;
  line-height: 24px;
  color: #000;
}

.error-icon {
  width: 30px;
  height: 30px;
}

/* 进场和退场动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SysAlert.vue